import { Building2, ChevronRight } from "lucide-react";
import type { AvailableAccount } from "@/shared/state/authstore";

type AccountPickerProps = {
  accounts: AvailableAccount[];
  onSelect: (account: AvailableAccount) => void;
};

export function AccountPicker({ accounts, onSelect }: AccountPickerProps) {
  return (
    <div className="space-y-3">
      {accounts.map((account) => {
        const isAccessible = account.accessible !== false;
        return (
          <button
            key={account.accountId}
            onClick={() => (isAccessible ? onSelect(account) : undefined)}
            disabled={!isAccessible}
            className="group w-full flex items-center gap-4 rounded-xl border border-line p-4 text-left transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-hover hover:border-indigo-300 hover:shadow-sm disabled:hover:bg-transparent disabled:hover:border-line disabled:hover:shadow-none"
          >
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-indigo-50 text-indigo-600 transition-colors group-hover:bg-indigo-100">
              <Building2 className="h-6 w-6" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[15px] font-semibold text-ink truncate">{account.accountName}</p>
              <p className="text-sm text-ink-3 truncate mt-0.5">
                {account.domain} &middot; {account.employeeType}
              </p>
              {!isAccessible && (
                <p className="text-xs text-ink-4 mt-0.5">Not available for the back-office</p>
              )}
            </div>
            {isAccessible && (
              <ChevronRight className="h-5 w-5 shrink-0 text-ink-4 group-hover:text-indigo-600 transition-colors" />
            )}
          </button>
        );
      })}
    </div>
  );
}
